// extracted by mini-css-extract-plugin
module.exports = {"searchWrapper":"Search_searchWrapper___5q9C"};